import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { UserSignOut } from "../../shared/store/actions/userActions";
import { LoginApi } from '../login/LoginApi'

export const SignoutContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        const performLogout = async () => {
            try {
                // Call server to clear auth cookie
                await LoginApi.logout()
            } catch (error) {
                console.error('Logout API error:', error)
            } finally {
                // Always clear local state
                dispatch(UserSignOut())
                history.push('/login')
            }
        }

        performLogout()
    }, [])

    return null;
}